export default "__VITE_ASSET__10645798__"